import { render, staticRenderFns } from "./PatientLogin.vue?vue&type=template&id=00db4794&scoped=true"
import script from "./PatientLogin.vue?vue&type=script&lang=js"
export * from "./PatientLogin.vue?vue&type=script&lang=js"
import style0 from "./PatientLogin.scss?vue&type=style&index=0&id=00db4794&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00db4794",
  null
  
)

export default component.exports